import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editTimeRecordsListingConfiguration(
    req: Boundaries["editTimeRecordsListingConfiguration"]["request"],
  ): void;
}

function useEditTimeRecordsListingConfiguration(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditTimeRecordsListingConfigurationRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditTimeRecordsListingConfigurationRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditTimeRecordsListingConfigurationRequestFailure(planzone),
    ),
    editTimeRecordsListingConfiguration:
      core.editTimeRecordsListingConfiguration,
  };
}

export { useEditTimeRecordsListingConfiguration };
